import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import * as Buttons from 'theme/components/Buttons.style';
import * as Text from 'theme/components/Text.style';

export const Wrapper = styled.div<{ $inline?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $inline }) => ($inline ? '100%' : '382px')};
`;

export const ErrorPill = styled.div`
  align-items: flex-start;
  align-self: flex-start;
  background: ${colours.error[50]};
  border-radius: 20px;
  box-sizing: border-box;
  color: ${colours.error[800]};
  display: inline-flex;
  gap: 8px;
  padding: 15px;
  width: 100%;
`;

export const ErrorPillBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  min-width: 0;
`;

export const ErrorPillText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ErrorPillLabel = styled(Text.P2Semibold)`
  color: inherit;
`;

export const ErrorPillReason = styled(Text.P1)`
  color: ${colours.error[800]};
  opacity: 0.9;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const ErrorActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const DismissAction = styled(Buttons.Ghost)`
  background-color: ${colours.error[100]};
  color: ${colours.error[700]};

  svg path {
    stroke: ${colours.error[700]};
  }

  &:hover,
  &:focus {
    background-color: ${colours.error[100]};
  }
`;

export const RetryAction = styled(Buttons.SecondaryDark)`
  background-color: ${colours.error[700]};
  color: ${colours.shade[0]};

  svg path {
    stroke: ${colours.shade[0]};
  }

  &:hover,
  &:focus {
    background-color: ${colours.error[800]};
  }
`;

export default Wrapper;
